
/**
 * 
 * @param string puzzleString - puzzle string data
 * @param int cols - number of columns
 * 
 * @return a 2d number integer array
 */
function stringTo2dArray( puzzleString, cols ) 
{ 
    var i,j,temparray,chunk = cols
    var flat = Array.from(puzzleString.split(''), Number)
    var gridArray = []
    
    for (i=0,j=flat.length; i<j; i+=chunk) {
        temparray = flat.slice(i,i+chunk)
        gridArray.push(temparray)
    }
    
    return gridArray
}

function arraysEqual(a, b) 
{
    a = Array.isArray(a) ? a : [];
    b = Array.isArray(b) ? b : [];
    return a.length === b.length && a.every((el, ix) => el === b[ix]);
}

function shuffle(array) 
{
    let currentIndex = array.length,  randomIndex
    while (currentIndex != 0) 
    {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }
    return array;
}

function normalize(val, max, min) { 
    return (val - min) / (max - min); 
}


export { stringTo2dArray, arraysEqual, shuffle, normalize }
